/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S43_IntroInputs */

const es_tyc_obligations_s43_intro = /** @type {(inputs: Tyc_Obligations_S43_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata se esfuerza por proporcionar resultados precisos basados en el estado actual de sus Fuentes Conectadas. Sin embargo:`)
};

const en_tyc_obligations_s43_intro = /** @type {(inputs: Tyc_Obligations_S43_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata strives to provide accurate results based on the current state of your Connected Sources. However:`)
};

/**
* | output |
* | --- |
* | "Nexata strives to provide accurate results based on the current state of your Connected Sources. However:" |
*
* @param {Tyc_Obligations_S43_IntroInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s43_intro = /** @type {((inputs?: Tyc_Obligations_S43_IntroInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S43_IntroInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s43_intro(inputs)
	return en_tyc_obligations_s43_intro(inputs)
});
export { tyc_obligations_s43_intro as "tyc.obligations.s43_intro" }